export enum ApiErrorHandlerConstants {
  RESET_API_ERROR_HANDLER = 'apiErrorHandler/RESET_API_ERROR_HANDLER',
  SHOW_ALERT = 'apiErrorHandler/SHOW_ALERT',
  SHOW_TOAST = 'apiErrorHandler/SHOW_TOAST',
  HANDLE_API_ERROR = 'apiErrorHandler/HANDLE_API_ERROR',
  SET_ERROR_MESSAGE = 'apiErrorHandler/SET_ERROR_MESSAGE',
  SET_CALLBACK = 'apiErrorHandler/SET_CALLBACK',
  SET_BUTTONS = 'apiErrorHandler/SET_BUTTONS',
  SET_HEADER = 'apiErrorHandler/SET_HEADER',
  SET_ERROR_TOAST_DURATION = 'apiErrorHandler/SET_ERROR_TOAST_DURATION',
}
